module.exports = __webpack_public_path__ + "img/assault_tank_factory_small.cffbaf2e.png";